import React, { useState, useContext } from "react";
import useContextMenu from "../../contexts/useContextMenu";
import SocketContext from "../../contexts/SocketContext";

const ProdCatNameListSelector = ({
  singleProdGroupData,
  selectedProdCatName,
  setSelectedProdCatName,
  setSelectedProdCatNameID,
  setSelectedProdName,
  setShowProdDetails,
  setSelectedProduct,
  setSelectedProducer,
  setProdCatNameEdits,
  setEditingPCN,
  selectedProduct,
}) => {
  const { clicked, setClicked, points, setPoints } = useContextMenu();
  const [activeIndex, setActiveIndex] = useState();

  // Socket
  const { socket } = useContext(SocketContext);

  // Leave Product Room Promise
  const leaveroom = (item) => {
    return new Promise((resolve, reject) => {
      socket.emit("leaveproductRoom", selectedProduct.productID);
      resolve();
    });
  };

  // Select Product
  const selectProduct = async () => {
    if (selectedProduct && selectedProduct.productID) {
      await leaveroom(selectedProduct.productID);
    }
  };
  return (
    <div className='prodCatNameListSelector'>
      {singleProdGroupData && (
        <h3 style={{ position: "sticky", top: 0, background: "var(--white)" }}>Select ProdCatName:</h3>
      )}
      {singleProdGroupData
        ? Object.keys(singleProdGroupData)
            .sort()
            .map((key, index) => {
              if (key !== "null") {
                return (
                  <>
                    <p
                      onClick={(e) => {
                        selectProduct();
                        setSelectedProdCatName(key);
                        setSelectedProdCatNameID(singleProdGroupData[key][0]["prodCatNameID"]);
                        setSelectedProdName("");
                        setShowProdDetails("");
                        setSelectedProduct(null);
                        setSelectedProducer("");
                        // setProdCatNameEdits({
                        //   ["prodCatNameID"]:
                        //     singleProdGroupData[key][0]["prodCatNameID"],
                        //   ["prodCatName"]: key,
                        // });
                        setClicked(false);
                        setEditingPCN(false);
                      }}
                      key={key}
                      className={selectedProdCatName === key ? "activeListSelector" : ""}
                      onContextMenu={(e) => {
                        e.preventDefault();
                        selectProduct();
                        setSelectedProdCatName(key);
                        setSelectedProdCatNameID(singleProdGroupData[key][0]["prodCatNameID"]);
                        setSelectedProdName("");
                        setShowProdDetails("");
                        setSelectedProduct(null);
                        setSelectedProducer("");
                        // setProdCatNameEdits({
                        //   ["prodCatNameID"]:
                        //     singleProdGroupData[key][0]["prodCatNameID"],
                        //   ["prodCatName"]: key,
                        // });
                        setClicked(true);
                        setPoints({ x: e.pageX, y: e.pageY });
                        setActiveIndex(index);
                        setEditingPCN(false);
                      }}
                    >
                      {key}
                    </p>
                    <div style={{ position: "relative", overflow: "visible" }}>
                      {clicked && activeIndex === index && (
                        <div className='contextMenu'>
                          <ul onContextMenu={(e) => e.preventDefault()}>
                            <li
                              onClick={(e) => {
                                setEditingPCN(true);
                                setClicked(false);
                                setSelectedProdName("");
                                setShowProdDetails("");
                                setSelectedProduct(null);
                                setSelectedProducer("");
                                setProdCatNameEdits({
                                  ["prodCatNameID"]: singleProdGroupData[key][0]["prodCatNameID"],
                                  ["prodCatName"]: key,
                                });
                              }}
                            >
                              Edit
                            </li>
                            <li>Delete</li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </>
                );
              }
            })
        : ""}
    </div>
  );
};

export default ProdCatNameListSelector;
